import SsHeadline from "components/front/layout/SsHeadline";
import { SectionContent } from "components/front/project/SectionContent";
import Section from "components/front/project/layout/Section";
import React from "react";

export type Props = {
  corporateLogo: string;
};
const CorporateLogoSection = ({ corporateLogo }: Props) => {
  return (
    <Section>
      <SsHeadline label="応援企業様" color="white" />
      <SectionContent content={corporateLogo} />
    </Section>
  )
};
export default CorporateLogoSection;
